import React, { useEffect, useState, useCallback } from 'react'
import { isEmpty } from 'lodash'
import FILTERED_TYPE from '../constant'
import { showActiveFilters } from '../helpers/helpersTable'
import { showActiveFiltersPivot } from '../helpers/helpersPivot'
import { isNameAlreadyStored } from '../storeUtils'
import LoadingModal from '../../LoadingModal'
import TextInput from '../../TextInput'
import ActiveFilters from '../../ActiveFilters'

const TableSaveFilterModal = ({ open, close, data }) => {
  const { tableApi, onSave, t, type, identifier, linksByUri, userId } = data
  const [columnsInfo, setColumnsInfo] = useState([])
  const [isInvalidName, setIsInvalidName] = useState(false)
  const [filterName, setFilterName] = useState('')
  const [ubliqueLinks, setUbliqueLinks] = useState([])

  useEffect(() => {
    if (open) {
      if (type === FILTERED_TYPE.TABLE) setUbliqueLinks(linksByUri())
    }
  }, [open])

  useEffect(() => {
    if (tableApi) {
      type === FILTERED_TYPE.PIVOT
        ? setColumnsInfo(tableApi.gridCore.columnApi.getColumnState())
        : setColumnsInfo(tableApi.gridCore.filterManager.getFilterModel())
    }
  }, [tableApi])

  const onSaveModal = () => {
    if (
      !filterName ||
      isEmpty(filterName) ||
      isNameAlreadyStored(filterName, type, identifier, userId)
    ) {
      setIsInvalidName(true)
      return
    }

    onSave(filterName, columnsInfo, type)
    close()
  }
  const onChange = ({ target: { value } }) => {
    setFilterName(value)
    isEmpty(value) ? setIsInvalidName(true) : setIsInvalidName(false)
  }

  const onClose = () => {
    close()
    setIsInvalidName(false)
  }

  const activeFilters =
    type === FILTERED_TYPE.PIVOT
      ? showActiveFiltersPivot(columnsInfo, tableApi, t)
      : showActiveFilters(columnsInfo, tableApi, ubliqueLinks)

  const customHeaderModal = useCallback(() => {
    return (
      <div className='modal-header bx--modal-header__heading'>
        <h4>{t('FilterMenu.ColumnsFilterButtonTable.TITLE')}</h4>
      </div>
    )
  }, [t])

  return (
    <LoadingModal
      size='md'
      open={open}
      onRequestClose={onClose}
      onRequestSubmit={onSaveModal}
      secondaryButtonText={t('Translations:Cancel')}
      primaryButtonText={t('Translations:Save')}
      modalHeading={customHeaderModal()}
      className='columnsFilter-modal-inputview'
      preventCloseOnClickOutside
    >
      <TextInput
        id='filterName'
        labelText={t('FilterMenu.ColumnsFilterButtonTable.INPUT_TITLE')}
        placeholder={t('FilterMenu.ColumnsFilterButtonTable.INPUT_PLACEHOLDER')}
        invalidText={t('FilterMenu.ColumnsFilterButtonTable.INVALID_INPUT')}
        invalid={isInvalidName}
        onChange={onChange}
        autoComplete='off'
      />
      <ActiveFilters filters={activeFilters} labels='' />
    </LoadingModal>
  )
}

export default TableSaveFilterModal
